import circleWordmark from "@circle-assets/images/opt-in/circle-wordmark.svg";
import eclipseModalBgLq from "@circle-assets/images/opt-in/eclipse-waitlist-modal-bg-lq.webp";
import eclipseModalBg from "@circle-assets/images/opt-in/eclipse-waitlist-modal-bg.webp";
import eclipseWordmark from "@circle-assets/images/opt-in/eclipse-wordmark.svg";
import { Modal } from "@circle-react-uikit/ModalV2";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Typography } from "@circleco/compass/components/Typography";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { ABOUT_CIRCLE_V4_PATH } from "../constants";

const CircleAIIntroModalComponent = () => {
  const modal = useModal();
  const navigate = useNavigate();

  const handleLearnMore = () => {
    void modal.hide();
    void navigate({ to: ABOUT_CIRCLE_V4_PATH });
  };

  return (
    <Modal isOpen={modal.visible} onClose={modal.hide}>
      <Modal.Overlay />
      <Modal.Content
        size="lg"
        className="!rounded-xl gap-6 bg-cover shadow-2xl sm:!w-[652px]"
        style={{
          backgroundImage: `url(${eclipseModalBg}), url(${eclipseModalBgLq}), linear-gradient(225deg, #BF4015 0%, #4A1060 45%, #08091A 65%, #112068 100%)`,
        }}
      >
        <Modal.Header>
          <Modal.HeaderActions className="ml-auto">
            <Modal.CloseButton
              iconClassName="!text-grey-50"
              className="hover:!bg-grey-50/10 focus-visible:!outline-none"
              onClick={modal.hide}
            />
          </Modal.HeaderActions>
        </Modal.Header>
        <Modal.Body className="flex flex-col items-center gap-6 px-6 pb-10 text-center">
          <div className="flex items-center rounded-full border border-white/35 bg-white/10 px-3 py-1.5 backdrop-blur-[2px]">
            <Typography variant="label-sm" className="text-grey-0">
              {t("circle_ai_intro_modal.badge")}
            </Typography>
          </div>

          <div className="flex max-w-[416px] flex-col items-center gap-4">
            <p className="text-xl font-medium leading-[44px] tracking-[-0.5px] text-grey-0">
              {t("circle_ai_intro_modal.introducing")}
            </p>

            <div className="flex items-start justify-center gap-3">
              <img
                src={circleWordmark}
                alt={t("circle_ai_intro_modal.logo_alt")}
                width={157}
                height={45}
                loading="eager"
              />
              <img
                src={eclipseWordmark}
                alt={t("circle_ai_intro_modal.logo_alt")}
                width={176}
                height={57}
                loading="eager"
              />
            </div>

            <div className="flex flex-col text-grey-50">
              <Typography variant="label-md" className="text-grey-50">
                {t("circle_ai_intro_modal.tagline")}
              </Typography>
              <Typography variant="body-md" className="text-grey-50">
                {t("circle_ai_intro.subtitle")}
              </Typography>
            </div>
          </div>

          <Button
            type="button"
            variant="circle"
            large
            className="!rounded-3xl !border-grey-900 !bg-grey-0 hover:!bg-grey-100"
            onClick={handleLearnMore}
          >
            <Typography variant="label-md" className="text-grey-900">
              {t("circle_ai_intro.learn_more")}
            </Typography>
          </Button>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

const CircleAIIntroModal = ModalManager.create(() => (
  <CircleAIIntroModalComponent />
));

export const useCircleAIIntroModal = () => useModal(CircleAIIntroModal);
